import { Directive, AfterViewInit, ElementRef, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[removeLeadingSpaces]',
})
export class RemoveLeadingSpacesDirective implements AfterViewInit {
  constructor(
    private el: ElementRef,
    @Optional() private ngControl: NgControl
  ) {}

  ngAfterViewInit(): void {
    const input = this.el.nativeElement.getElementsByTagName('input')[0];

    if (this.ngControl) {
      input &&
        input.addEventListener('blur', () => {
          const trimmedValue = this.ngControl.value?.replace(/^\s+/g, '');
          this.ngControl.control.setValue(trimmedValue);
        });
    } else {
      input &&
        input.addEventListener('blur', (evt) => {
          const initialValue = input.value;
          const trimmedValue = initialValue.replace(/^\s+/g, '');
          input.value = trimmedValue;
          if (initialValue !== input.value) {
            evt.stopPropagation();
          }
        });
    }
  }
}
